import { render } from "./Pensions.vue?vue&type=template&id=29c53e06&scoped=true"
import script from "./Pensions.vue?vue&type=script&lang=js"
export * from "./Pensions.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=29c53e06&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c53e06"]])

export default __exports__